import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';

export interface EditProductProps extends Omit<ProductProps, 'id'> {}

const useEditProduct = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) => {
    update(productsKeys.list(), data);
    setData(productsKeys.details(id), data);
  };

  return useApiMutation<EditProductProps>({
    url: `/products/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar produto',
    successTitle: 'Editar produto',
    successMessage: 'Produto atualizado com sucesso',
    onSuccess,
  });
};

export default useEditProduct;
